import React from 'react';
import { useDispatch } from 'react-redux';
import { object } from 'yup';
import styled from 'styled-components';
import { Formik, Form, useFormikContext } from 'formik';
import Field from 'antd-components/field';
import Input from 'antd-components/input';
import Button from 'antd-components/button';
import { ADMIN_GET_OTP_REQUEST, LOGIN_DASHBOARD_REQUEST } from '../Users/ducks';
import Notification from 'antd-components/notification';
import { validation } from 'dorothy/utils/validation';

const Container = styled.div`
  background-color: #eee;
  width: 100vw;
  height: 100vh;
  position: relative;
`;

export const StyledForm = styled.div`
  display: flex;
  justify-content: center;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);

  > div {
    width: 350px;
    padding: 30px 20px 40px 20px;
    background: white;

    .form {
      > *:not(:last-child) {
        margin-bottom: 15px;
      }

      h2 {
        text-align: center;
      }

      > div:last-child {
        width: 100%;
        button {
          display: flex;
          justify-content: center;
          align-items: center;
          margin-bottom: 15px;
          margin-top: 25px;
          height: 45px;
          text-transform: uppercase;
          font-weight: 500;
          width: 100%;
        }
      }
    }

    @media screen and (max-width: 480px) {
      width: calc(100% - 30px);
      max-width: calc(100% - 30px);
    }
  }
`;

const validationSchema = object().shape({
  username: validation.username,
  password: validation.password,
  code: validation.code,
});

const GetCodeButton = () => {
  const dispatch = useDispatch();
  const { values } = useFormikContext();

  const handleGetCode = () => {
    dispatch({
      type: ADMIN_GET_OTP_REQUEST,
      payload: {
        username: values.username,
        callBack: (success, data) => {
          if (success && data?.message) {
            Notification.success(data.message);
          } else {
            Notification.error('❌ Gửi OTP thất bại');
          }
        },
      },
    });
  };

  return (
    <Button htmlType="button" type="primary" onClick={handleGetCode}>
      GET CODE
    </Button>
  );
};

const Login = ({ history }) => {
  const dispatch = useDispatch();
  const initialValues = {
    username: '',
    password: '',
    code: ''
  };

  const renderForm = ({ handleSubmit, ...form }) => (
    <Form className="form">
      <h2>Đăng nhập</h2>
      <Field form={form} name="username" label="Tên tài khoản" component={Input} />
      <Field form={form} name="password" label="Mật khẩu" type="password" component={Input} />
      <Field form={form} name="code" label="OTP" type="text" component={Input} />
      <div style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            flex: 1,
            gap: '10px'
          }}>
        <GetCodeButton />
        <Button htmlType="submit" type="primary" onClick={handleSubmit}>
          Đăng nhập
        </Button>
      </div>
    </Form>
  );

  const onLogin = values => {
    dispatch({
      type: LOGIN_DASHBOARD_REQUEST,
      payload: {
        ...values,
        history,
        callBack: success => {
          if (success) Notification.success('Đăng nhập thành công');
        },
      },
    });
  };

  return (
    <Container>
      <StyledForm>
        <div>
          <Formik
            validateOnChange={false}
            validateOnBlur={false}
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={onLogin}
            component={renderForm}
          />
        </div>
      </StyledForm>
    </Container>
  );
};

export default Login;
